// frontend/src/utils/mailto.js
//
// The one builder for a `mailto:` link, and the one way to open it. A mail
// link is the SaaS's only way to hand a message to the merchant's own mail
// client: contacting sales from the billing surfaces. Everything the link
// carries is percent-encoded here, so a subject with an ampersand survives
// the URL.

import { clickAnchor } from './download';

/**
 * @param {{ to: string, subject?: string }} parts  A blank or missing subject
 *   is left out of the link rather than sent empty.
 * @returns {string} `mailto:<to>?subject=…`
 */
export function mailtoHref({ to, subject }) {
  // RFC 6068: `@` separates the mailbox from its host and stays bare.
  const address = encodeURIComponent(to).replace(/%40/g, '@');
  return subject ? `mailto:${address}?subject=${encodeURIComponent(subject)}` : `mailto:${address}`;
}

/** Hand the link to the merchant's mail client. */
export function openMailto(href) {
  clickAnchor({ href });
}
